import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../core/hooks/useAuth';
import { Button } from '../core/components/Button';
import { Card } from '../core/components/Card';
import { Input, Label } from '../core/components/FormElements';
import './LoginPage.css';

export const LoginPage: React.FC = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const navigate = useNavigate();
    const location = useLocation();

    const from = location.state?.from?.pathname || '/';

    const { login, loading, error } = useAuth({
        onAuthChange: (isAuthenticated) => {
            if (isAuthenticated) {
                navigate(from, { replace: true });
            }
        }
    });

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();

        if (!username || !password) {
            alert('Пожалуйста, заполните все поля');
            return;
        }

        setIsSubmitting(true);

        try {
            const response = await login({ username, password });

            if (response.success) {
                console.log('Успешная авторизация');
            }
        } catch (err) {
            const errorMessage = err instanceof Error ? err.message : 'Ошибка авторизации';
            alert(errorMessage);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="login-page">
            <Card className="login-container">
                <h1>Вход в систему</h1>

                {error && (
                    <div className="login-error">
                        {error}
                    </div>
                )}

                <form onSubmit={handleSubmit} className="login-form">
                    <div className="form-group">
                        <Label htmlFor="username">Имя пользователя:</Label>
                        <Input
                            type="text"
                            id="username"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            disabled={loading || isSubmitting}
                            required
                            placeholder="Введите имя пользователя"
                        />
                    </div>

                    <div className="form-group">
                        <Label htmlFor="password">Пароль:</Label>
                        <Input
                            type="password"
                            id="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            disabled={loading || isSubmitting}
                            required
                            placeholder="Введите пароль"
                        />
                    </div>

                    <Button
                        type="submit"
                        variant="primary"
                        loading={isSubmitting}
                        disabled={loading || isSubmitting || !username || !password}
                    >
                        Войти
                    </Button>
                </form>
            </Card>
        </div>
    );
};
